<template>
  <c-container>
    <v-row v-if="car">
      <!-- 車両名 (小さい画面用) -->
      <v-col
        v-if="$vuetify.breakpoint.smAndDown"
        cols="12"
      >
        <c-car-name :car="car"/>
      </v-col>

      <!-- 写真 -->
      <v-col cols="12" md="6">
        <c-car-images :images="car.details.images"/>

        <!-- (大きい画面用) -->
        <template v-if="$vuetify.breakpoint.smAndUp">
          <!-- スペック -->
          <h2 class="subtitle-1 my-4">主要諸元</h2>
          <c-data-table :data="specs" :table="true"/>

          <!-- 装備品 -->
          <h2 class="subtitle-1 my-4">装備品</h2>
          <c-data-table :data="equipments" :table="true"/>
        </template>
      </v-col>

      <v-col cols="12" md="6">
        <v-sheet rounded class="pa-4 mb-4">
          <!-- 車両名 (大きい画面用) -->
          <c-car-name
            class="mb-4"
            v-if="$vuetify.breakpoint.mdAndUp"
            :car="car"
          />

          <!-- 説明文 -->
          <c-car-description class="mb-4" :description="car.details.desc"/>

          <!-- タグ -->
          <div class="body-2">
            <div>車種: {{car.typeName}}</div>
            <div v-html="tags"></div>
            <div>
              <span>レンタル基本料金: {{car.chargeText}}</span>
            </div>
            <div
              v-show="enableCar24Flg"
              class="car_vkey_link"
            >
              <a :href="'/reserve/res/' + orgcode + '/vkey.pdf'">24時間貸出車両について</a>
            </div>
          </div>
        </v-sheet>

        <!-- (小さい画面用) -->
        <template v-if="!$vuetify.breakpoint.smAndUp">
          <!-- スペック -->
          <h2 class="subtitle-1 my-4">主要諸元</h2>
          <c-data-table :data="specs" :table="false"/>

          <!-- 装備品 -->
          <h2 class="subtitle-1 my-4">装備品</h2>
          <c-data-table :data="equipments" :table="false"/>
        </template>

        <!-- カレンダー -->
        <v-row>
          <v-col cols="12" lg="6">
            <c-calendar-month
              :stationID="stationID"
              :car="car"
              :dates="dates"
              :calendar="calendar"
              :states="states"
              :startDate="startDate"
              :returnDate="returnDate"
              :span="span"
              :spanText="spanText"
              @parent_selectDate="selectDate"
            />
            <div class="selectArea" id="selectArea">
              <div class="selectTitle">
                <span class="selectTitle_title">ご利用日</span><span class="selectTitle_span">{{spanText}}</span>
              </div>
              <div class="selectBox">
                <div class="selectFlexBox">
                  <div class="selectDateBox primary">
                    <div>ご出発</div>
                    <div class="selectDate" @click="dateMessage">{{startDate.date}}</div>
                  </div>
                  <div class="selectArrow"><span class="material-icons">double_arrow</span></div>
                  <div class="selectDateBox primary">
                    <div>ご帰着</div>
                    <div class="selectDate" @click="dateMessage">{{returnDate.date}}</div>
                  </div>
                </div>
                <div class="selectActions">
                  <v-btn class="grayOut" text v-if="nextButton">次へ</v-btn>
                  <v-btn class="primary" text @click="book" v-else>次へ</v-btn>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" lg="6">
            <v-toolbar-title class="h-10">車両の空き状況</v-toolbar-title>

            <v-sheet rounded class="pa-4">
              <p class="body-2 text--secondary">
                カレンダーには現在の車両の空き情報が表示されています。<br>
                予約の開始日をタップすると、予約入力を開始します。
              </p>

              <p>凡例</p>
              <!-- p class="body-2 text--secondary">
                ※ 凡例は画像に変更予定
              </p -->
              <p v-if="triangle" class="body-2 text--secondary">
                ○ ... 終日予約できます<br>
                △ ... 予約可能な時間があります<br>
                － ... 既に予約されています<br>
              </p>
              <p v-else class="body-2 text--secondary">
                ○ ... 予約可<br>
                － ... 予約不可<br>
              </p>
              <p class="body-2 text--secondary">
                青 ... キャンペーン期間<br>
                黄色 ... ハイシーズン期間
              </p>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </c-container>
</template>

<style>
@media screen and (min-width: 1024px) {
.car_vkey_link {
  width: 20%;
}
}
@media screen and (max-width: 1023px) {
.car_vkey_link {
  width: 60%;
}
}

.carname {
  width: 100%;
  border-bottom: solid 2px #ccc;
}
.carname_span {
  display: inline-block;
  padding: 4px 0;
  font-size: 1.2rem;
  font-color: red;
  text-align: left;
  margin-right: 8px;
}
.chargeText {
  margin-bottom: 8px;
}
.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
.car_vkey_link {
  margin-top: 12px;
}
.car_vkey_link > a {
  display: block;
  padding: 4px 8px;
  border-radius: 15px;
  border: 1px #cccccc solid;
  text-decoration: none;
  text-align: center;
}
.selectArea {
  margin-top: 16px;
  width: 100%;
}
.selectTitle {
  height: 2.5rem;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selectTitle_title {
  display: inline_block;
  float: left;
  font-size: 1.25rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}
.selectTitle_span {
  display: inline_block;
  float: right;
  margin-top: 0.7rem;
  padding: 2px 4px;
  font-size: 0.8rem;
  border-radius: 4px;
  border: 1px #fff solid;
  background-color: #fff;
}
.selectBox {
  margin-top: 4px;
  padding: 16px;
  width: 100%;
  border-radius: 4px;
  border: 1px #fff solid;
  background-color: #fff;
}
.selectFlexBox {
  display: flex;
  width: 100%;
}
.selectDateBox {
  display: block;
  padding: 4px;
  width: 40%;
  border-radius: 4px;
  border: 1px #ccc solid;
  background-color: #ccc;
  color: #fff;
}
.selectDate {
  border-radius: 4px;
  border: 1px #fff solid;
  background-color: #fff !important;
  color: #000;
  text-align: center;
}
.selectArrow {
  width: 19%;
  margin-top: 1rem;
  text-align: center;
}
.selectActions {
  display: block;
  width: 99%;
  margin: 0 auto;
  padding: 24px 0;
}
.selectActions > button {
  float: right;
  display: block;
}
.grayOut {
  background-color: #ccc;
  color: #888;
}
</style>

<script>
import { run } from '@/libs/a'
import page from '@/mixins/page'
import CCarName from './CCarName'
import CCarImages from './CCarImages'
import CCarDescription from './CCarDescription'
import CDataTable from './CDataTable'
import CCalendarMonth from './CCalendarMonth'
import * as CCalendar from '@/components/CCalendar'
import store from '@/store'
// import * as C from '@/consts'

import * as api from '@/api'
import { getSpecs, getEquipments } from './data-tables'

export default {
  name: 'Car',
  mixins: [
    page('車両詳細')
  ],
  components: {
    CCarName,
    CCarImages,
    CCarDescription,
    CDataTable,
    CCalendarMonth
  },

  /**
   * データ取得
   */
  async prepare (to) {
    // ステーションID, 車両ID を to から取得する
    const stationID = to.params.stid - 0
    const shopID = (stationID / 100) | 0
    const carID = to.params.carid - 0
    const orgcode = to.params.orgcode

    const results = await Promise.all([
      // 車両情報を取得する
      api.getShopCar(shopID, carID, [
        'maker',
        'name',

        'classID',
        'className',
        'chargeText',

        'category',
        'categoryName',
        'type',
        'typeName',

        'attributes',
        'details'
      ]),

      // カレンダーを取得する
      api.getShopCalendar(shopID)
    ])

    // 車両カテゴリから予約可能期間を取得する
    const car = results[0].data
    const calendar = results[1].data
    let category = calendar.categories.find(item => item.category === car.category)
    if (!category) {
      category = calendar.categories[0]
    }

    // 車両の空き状況を取得する
    const resp = await api.getAvailableDays(shopID, category.allow.begin, category.allow.end, carID)
    const spans = resp.data[carID]

    // CCalendar 用のカレンダー情報を作成する
    const cal = CCalendar.createCalendar(calendar)

    // CCalendar 用の各日付の状態を作成する
    const states = CCalendar.createStates(cal.dates, spans)

    // 24h対応
    let enableCar24Flg = false
    if (car.attributes.keykey === 1 || car.attributes.vkey === 1) {
      enableCar24Flg = true
    }

    // カレンダー表示タイプを取得
    const calendarType = store.getters['org/calendarType']
    let triangle = true
    if (calendarType === 1) {
      triangle = false
    }

    return {
      stationID,
      car,
      dates: cal.dates,
      calendar: cal.calendar,
      states,
      enableCar24Flg,
      triangle,
      orgcode,
      span: category.span
    }
  },

  props: {
    orgcode: String,
    stationID: Number,
    car: Object,
    dates: Array,
    calendar: Object,
    states: Object,
    enableCar24Flg: {
      type: Boolean,
      default: false
    },
    triangle: {
      type: Boolean,
      default: false
    },
    span: Object
  },

  data () {
    return {
      startDate: {
        date: 'ご選択ください',
        begin: '',
        end: ''
      },
      returnDate: {
        date: 'ご選択ください',
        begin: '',
        end: ''
      },
      nextButton: true
    }
  },

  computed: {
    tags () {
      const tags = []

      const attrs = this.car.attributes

      if (attrs.vkey || attrs.keykey) {
        tags.push('24h貸出')
      }

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.drive === 1) {
        tags.push('4WD')
      }

      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      if (attrs.tags) {
        tags.push(...attrs.tags)
      }

      return this.tags_html(tags)
    },

    specs () {
      return getSpecs(this.car.attributes, this.car.details.specs || [])
    },

    equipments () {
      return getEquipments(this.car.attributes, this.car.details.equipments || [])
    },

    spanText () {
      const spanArr = this.span

      if (typeof spanArr === 'object') {
      } else {
        return
      }

      if (Object.keys(spanArr).length > 0) {
      } else {
        return
      }

      let min = spanArr.min
      let max = spanArr.max
      min = min.replace('hours', '時間')
      min = min.replace('days', '日')
      min = min.replace('weeks', '週間')
      min = min.replace('month', 'ヶ月')
      max = max.replace('hours', '時間')
      max = max.replace('days', '日')
      max = max.replace('weeks', '週間')
      max = max.replace('month', 'ヶ月')

      return '利用可能期間　' + min + ' ～ ' + max
    }
  },

  methods: {
    dateMessage () {
      alert('上のカレンダーから日付を選択してください')
    },

    selectDate (date) {
      this.startDate = date.startDate
      this.returnDate = date.returnDate

      // 次へボタン
      if (this.startDate.date !== 'ご選択ください' && this.returnDate.date !== 'ご選択ください') {
        this.nextButton = false
      } else {
        this.nextButton = true
        return
      }

      // スクロール
      // const y = window.scrolly

      // documentのサイズ
      // const w = document.documentElement.scrollWidth
      // const h = document.documentElement.scrollHeight

      // document表示部分のサイズ
      // const vw = document.documentElement.clientWidth
      const vh = document.documentElement.clientHeight

      // documentのスクロール量
      // const x = document.documentElement.scrollLeft
      // const y = document.documentElement.scrollTop

      // カレンダーの位置を取得
      // const cl = document.getElementById('c-calendar')
      // const cxy = cl.getBoundingClientRect()

      // 次へボタンの位置を取得
      const next = document.getElementById('selectArea')
      const nextPos = next.getBoundingClientRect()
      const nextButtonY = nextPos.top + 150

      // 次へボタンがスクロール表示内かどうか
      if (nextButtonY > vh) {
        window.scrollBy(0, nextButtonY - vh + 50)
      }
      // console.log('w=' + w + ', h=' + h + ', vw=' + vw + ', vh=' + vh + ', x=' + x + ', y=' + y + ', cy=' + cxy.top)
      // console.log('vh=' + vh + ', y=' + y + ', nextButtonY=' + nextButtonY)
    },

    book () {
      run(async () => {
        if (this.startDate.date !== 'ご選択ください' && this.returnDate.date !== 'ご選択ください') {
        } else {
          alert('日付を選択してください')
          return
        }

        if (this.startDate.date <= this.returnDate.date) {
        } else {
          alert('日付を選択してください')
          return
        }

        const startDateTime = this.startDate.date + ' ' + this.startDate.begin
        let returnDateTime = this.returnDate.date + ' ' + this.returnDate.begin
        if (this.startDate.date === this.returnDate.date) {
          returnDateTime = this.returnDate.date + ' ' + this.returnDate.end
        }

        await this.dispatch('book/init', {
          stationID: this.stationID,
          allow: undefined,
          schedule: {
            begin: startDateTime,
            end: returnDateTime,
            refer: 'car'
          },
          car: this.car
        })

        // book に移動
        this.goTo({ name: 'book' })
      })
    },

    font_color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'Attributes_Dark'
      } else {
        ClassName = 'Attributes_Bright'
      }
      // 暫定で
      ClassName = 'Attributes_Dark'
      return ClassName
    },

    tags_html (tags) {
      // 配列かどうか
      if (Array.isArray(tags)) {
      } else {
        return
      }

      // テーマ色設定
      const FontColor = this.font_color_class()
      const SpanTag = '<span class="AttributesIcon ' + FontColor + ' primary">'

      // HTMLタグに変換
      let HTML = ''
      for (let i = 0; i < tags.length; i++) {
        HTML = HTML + SpanTag + tags[i] + '</span>'
      }

      return HTML
    }
  }
}
</script>
